<script>
import IconNote from '@/components/icon/IconNote.vue';
import constants from '@/constants';

export default {
    name: 'ButtonPublisherRequests',

    components: {
        ButtonIcon: IconNote,
    },

    computed: {
        constants() {
            return constants;
        },
        canAccess() {
            return !!(
                this.$store.getters.USER_PERMISSIONS &&
                this.$store.getters.USER_PERMISSIONS.can_manage_publishers
            );
        },
    },
};
</script>

<template>
    <router-link
        v-if="canAccess"
        class="left_button_main_container"
        :to="{ name: constants.ROUTER_NAME.PUBLISHER_MATERIAL_REQUESTS }"
    >
        <div class="left_button_icon_container">
            <ButtonIcon iconWidth="16px" iconHeight="16px" />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Publisher Requests</label>
        </div>
    </router-link>
</template>
